import type { ReactNode } from 'react';

/**
 * The full-width teal notice box of the Brand information card (spec:188): the action on the left (the
 * onboarding button), then an icon and the text. No `role`: it is part of the page, not an alert, so it
 * is not announced on every load (AlertBanner always is). Below `sm` the action sits above the text.
 */
export function NoticeBox({ action, icon, children }: { action?: ReactNode; icon: ReactNode; children: ReactNode }) {
  return (
    <div className="flex w-full flex-col gap-3 rounded-xl border border-teal-line bg-teal-tint px-4 py-3 sm:flex-row sm:items-center">
      {action && <div className="shrink-0">{action}</div>}
      <div className="flex min-w-0 items-start gap-2 text-sm text-ink">
        <span className="mt-0.5 flex shrink-0 text-teal">{icon}</span>
        <div className="min-w-0">{children}</div>
      </div>
    </div>
  );
}
